import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ResellerState } from '../reducers';

export const selectResellerState = createFeatureSelector<ResellerState>('reseller');

export const selectResellerLoading = createSelector(
  selectResellerState,
  (state: ResellerState) => state.loading
);

export const selectResellerEditMode = createSelector(
  selectResellerState,
  (state: ResellerState) => state.editMode
);

export const selectResellerIsEditing = createSelector(
  selectResellerState,
  (state: ResellerState) => state.isEditing
);

export const selectReseller = createSelector(
  selectResellerState,
  (state: ResellerState) => state.reseller
);

export const selectResellerList = createSelector(
  selectResellerState,
  (state: ResellerState) => state.resellerList
);

export const selectResellerForm = createSelector(
  selectResellerState,
  (state: ResellerState) => state.resellerForm
);

export const selectResellerError = createSelector(
  selectResellerState,
  (state: ResellerState) => state.error
);

export const selectResellerId = createSelector(
  selectResellerState,
  (state: ResellerState) => state.resellerId
)
